import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ConnectivityTest200,
  SimpleTest200,
  SimpleTestBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 기본 AI 모델의 동작을 테스트합니다.
 * @summary 간단한 AI 모델 테스트
 */
export const simpleTest = (
    simpleTestBody: SimpleTestBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SimpleTest200>(
      {url: `https://ai.ugot.uk/api/ai/v2/test/simple`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simpleTestBody
    },
      options);
    }
  


export const getSimpleTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simpleTest>>, TError,{data: SimpleTestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof simpleTest>>, TError,{data: SimpleTestBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simpleTest>>, {data: SimpleTestBody}> = (props) => {
          const {data} = props ?? {};

          return  simpleTest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SimpleTestMutationResult = NonNullable<Awaited<ReturnType<typeof simpleTest>>>
    export type SimpleTestMutationBody = SimpleTestBody
    export type SimpleTestMutationError = unknown

    /**
 * @summary 간단한 AI 모델 테스트
 */
export const useSimpleTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simpleTest>>, TError,{data: SimpleTestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof simpleTest>>,
        TError,
        {data: SimpleTestBody},
        TContext
      > => {

      const mutationOptions = getSimpleTestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 각 AI 모델과의 연결 상태를 테스트합니다.
 * @summary 모델 연결 테스트
 */
export const connectivityTest = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectivityTest200>(
      {url: `https://ai.ugot.uk/api/ai/v2/test/connectivity`, method: 'GET', signal
    },
      options);
    }
  

export const getConnectivityTestQueryKey = () => {
    return [`https://ai.ugot.uk/api/ai/v2/test/connectivity`] as const;
    }

    
export const getConnectivityTestInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof connectivityTest>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof connectivityTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConnectivityTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof connectivityTest>>> = ({ signal }) => connectivityTest(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof connectivityTest>>, TError, TData> & { queryKey: QueryKey }
}

export type ConnectivityTestInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof connectivityTest>>>
export type ConnectivityTestInfiniteQueryError = unknown

/**
 * @summary 모델 연결 테스트
 */
export const useConnectivityTestInfinite = <TData = Awaited<ReturnType<typeof connectivityTest>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof connectivityTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConnectivityTestInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConnectivityTestQueryOptions = <TData = Awaited<ReturnType<typeof connectivityTest>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof connectivityTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConnectivityTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof connectivityTest>>> = ({ signal }) => connectivityTest(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof connectivityTest>>, TError, TData> & { queryKey: QueryKey }
}

export type ConnectivityTestQueryResult = NonNullable<Awaited<ReturnType<typeof connectivityTest>>>
export type ConnectivityTestQueryError = unknown

/**
 * @summary 모델 연결 테스트
 */
export const useConnectivityTest = <TData = Awaited<ReturnType<typeof connectivityTest>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof connectivityTest>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConnectivityTestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



